import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstThenLastName'
})
export class FirstThenLastNamePipe implements PipeTransform {
  /**
   * Transform a name like "Smith, John" to "John Smith".
   *
   * @param lastThenFirstName The last name first, separated by a comma.
   * @param defaultValue The default value to display if the given value is invalid.
   * @returns A string where the first name comes before the last name.
   */
  transform(lastThenFirstName: string, defaultValue: string = ''): string {
    if (typeof lastThenFirstName !== 'string') {
      return defaultValue;
    }
    return lastThenFirstName
      .split(', ')
      .reverse()
      .join(' ');
  }
}
